import _ from 'lodash';
import BaseCtrl from 'edge/platform/base/BaseCtrl';
import 'gw-portals-util-js/FunUtil';
import { PhoneNumberUtil } from 'libphonenumber';
import ApplicationFeatures from 'gw-portals-featuredetection-js/ApplicationFeatures';
import nameUtil from 'edge/gateway/util/NameUtil';

const fn = ($translate, $state, $scope, $q, $stateParams, AccountService, PolicyService, ActivityService, $modal, $window, ModalService, $filter, UserService, TranslateService, defaultLocaleDetails) => {
    const ctrl = Object.create(BaseCtrl);

    const phoneUtils = PhoneNumberUtil.getInstance();

    ctrl.init = () => {
        addRecentlyViewedPolicies();
        initialiseScopeVariables();
        $scope.showComplaintActivity = true;


        const policyRequest = PolicyService.getPolicy($stateParams.policyNumber);
        policyRequest.then(
            (policy) => {
                if (!policy.policyNumber) {
                    const msg = $translate(
                        'gateway.views.policy-detail.findPolicy.nopolicy',
                        { policyNumber: $stateParams.policyNumber }
                    );
                    ModalService.showError('gateway.views.modal.Error', msg);
                    $state.go('policies.index');
                }
                $scope.title = null
                $scope.productNames = null
                $scope.policy = policy;
                $scope.accountInfo = {};
                $scope.latestPeriod = policy.latestPeriod;
                $scope.product = policy.product;
                mapAccountDetails(policy.account);

                // PSA: extracts PUW specific coverages with prices
                // NOTE: cannot use generic $scope.submission.policy.coverables.coverages since it doesn't have (line specific) prices
                $scope.isPuwPolicy = false;
                $scope.isEGVNPolicy = false;
                if (Object.keys($scope.policy.lobs.puw_PSA).length != 0) {
                    $scope.isPuwPolicy = true;
                    $scope.puwCoveragesPSA = [];
                    $scope.policy.lobs.puw_PSA.vehicleDTOs.forEach(coverable => {
                        if (coverable.coverages.length > 0) {
                            $scope.puwCoveragesPSA = $scope.puwCoveragesPSA.concat(_.flatten(coverable.coverages));
                        }
                    });
                }
                if (Object.keys($scope.policy.lobs.egvn_psa).length != 0) {
                    $scope.isEGVNPolicy = true;
                    $scope.egvnCoveragesPSA = [];
                    $scope.policy.lobs.egvn_psa.vehicleDTOs.forEach(coverable => {
                        if (coverable.coverages.length > 0) {
                            $scope.egvnCoveragesPSA = $scope.egvnCoveragesPSA.concat(_.flatten(coverable.coverages));
                        }
                    });
                }
                // UCWAR-672
                if ($scope.policy.latestPeriod.virtualProduct_PSA == ('EGVO Standalone ' + $scope.policy.latestPeriod.producerCodeCountry)) {
                    $scope.title = $scope.policy.latestPeriod.virtualProduct_PSA + " (" + $scope.latestPeriod.policyNumber + ")"
                } else if ($scope.policy.latestPeriod.virtualProduct_PSA == ('EGVO ' + $scope.policy.latestPeriod.producerCodeCountry)) {
                    $scope.title = "EGVO JV " + $scope.policy.latestPeriod.producerCodeCountry + " (" + $scope.latestPeriod.policyNumber + ")"
                } else if (($scope.policy.policyManagementType_PSA == 'insured') || ($scope.policy.policyManagementType_PSA == 'delegated')) {
                    const productTitle = $filter('translate')('policy.common.directives.templates.policy-common-details.Used Car Warranty');
                    //$scope.title = productTitle + " (GVO) (" + $scope.latestPeriod.policyNumber + ")"
                    var GWUserLanguage = localStorage.getItem('localLanguage');
                    if (GWUserLanguage == 'de') {
                        $scope.title = productTitle + "(" + $scope.latestPeriod.policyNumber + ")";
                    }
                    else {
                        $scope.title = productTitle + " (GVO) (" + $scope.latestPeriod.policyNumber + ")"
                    }
                } else if ($scope.policy.latestPeriod.virtualProduct_PSA == 'Estensione di garanzia Italy') { //UCWAR-1675
                    $scope.title = "EGVO JV Italy" + " (" + $scope.latestPeriod.policyNumber + ")"
                } else if ($scope.policy.latestPeriod.virtualProduct_PSA == 'Estensione di garanzia Standalone Italy') { //UCWAR-2066
                    $scope.title = "EGVO Standalone Italy" + " (" + $scope.latestPeriod.policyNumber + ")"
                } else if ($scope.policy.latestPeriod.virtualProduct_PSA == 'LGG JV Germany') { //UCWAR-1675
                    $scope.title = "LGG JV Germany" + " (" + $scope.latestPeriod.policyNumber + ")"
                } else if ($scope.policy.policyManagementType_PSA == 'self-managed') {
                    $scope.title = "Nouvelle Prestation Obligatoire (NPO) (" + $scope.latestPeriod.policyNumber + ")"
                } else {
                    $scope.title = $scope.policy.latestPeriod.virtualProduct_PSA + " (" + $scope.latestPeriod.policyNumber + ")"
                }
            },
            () => {
                const msg = $translate(
                    'gateway.views.policy-detail.findPolicy.nopolicy',
                    { policyNumber: $stateParams.policyNumber }
                );
                ModalService.showError('gateway.views.modal.Error', msg);
                $state.go('policies.index');
            }
        );

        const billingPromise = getPolicyBillingSummary($scope.policyNumber);
        billingPromise.then(
            (policyBillingSummary) => {
                $scope.policyBillingSummary = policyBillingSummary;
                if (angular.isDefined($scope.policyBillingSummary.policyPeriodBillingSummaries)) {
                    if ($scope.policyBillingSummary.policyPeriodBillingSummaries[0].isDelinquent) {
                        $scope.billingIcon = 'icon-error fa-exclamation-triangle';
                    }
                }
            },
            () => {
                ModalService.showError('gateway.views.modal.Error', $filter('translate')('gateway.directives.PolicyBillingSummaryDirective.policy-billing-summary.Failed to retrieve policy billing data'));
            }
        );

        $scope.policyLoadedPromise = $q.all([policyRequest, billingPromise]);
    };

    function shouldShowCommissionsButton() {
        const permissionDTO = {
            permission: 'viewcommissions'
        };

        UserService.hasUserSystemPermission(permissionDTO).then((canViewCommissionStatements) => {
            $scope.showCommissions = canViewCommissionStatements;
        });
    }

    /* Private Functions*/
    function initialiseScopeVariables() {
        $scope.billingFeatureTurnedOn = ApplicationFeatures.getAllFeatures().gatewayBilling === 'true';
        $scope.activitiesTurnedOnPSA = ApplicationFeatures.getAllFeatures().disableActivities_PSA !== 'true'; // PSA
        $scope.notesTurnedOnPSA = ApplicationFeatures.getAllFeatures().disableNotes_PSA !== 'true'; // PSA
        $scope.documentsTurnedOnPSA = ApplicationFeatures.getAllFeatures().disableDocuments_PSA !== 'true'; // PSA
        shouldShowCommissionsButton();

        $scope.policyTransactionTableConfig = {
            transactionStatus: '',
            policyTransactionStatus: [],
            source: 'account',
            search: ''
        };

        getPolicyTransactionStatus();

        $scope.activityTableConfig = {
            actStatus: 'allOpen',
            defaultActStatus: 'allOpen',
            actStatusOptions: {
                'allOpen': 'gateway.directives.ActivitySummary.All Open',
                'allClosed': 'gateway.directives.ActivitySummary.All Closed',
                'overdue': 'gateway.directives.ActivitySummary.Overdue',
                'openAssignedToMe': 'gateway.directives.ActivitySummary.Open, Assigned to me'
            },
            showAddActivity: false
        };

        $scope.documentMetaDataTemplate = {
            docUID: '001',
            documentType: 'letter_received',
            securityType: 'unrestricted',
            status: 'approved',
            policyNumber: $stateParams.policyNumber
        };

        $scope.policyNumber = $stateParams.policyNumber;
        $scope.formIsOpen = false;
        $scope.cancelFormIsVisible = false;
        $scope.changeFormIsVisible = false;
        $scope.renewFormIsVisible = false;

        const applicationFeatures = ApplicationFeatures.getAllFeatures();
        $scope.enableClaims = applicationFeatures.gatewayclaims === 'true';

        $scope.billingIcon = 'gw-icon-done fa-thumbs-o-up';
    }

    function getPolicyTransactionStatus() {
        const status = [{
            value: 'all',
            name: '',
            displayKey: 'gateway.views.account-detail.All'
        }, {
            value: 'Draft',
            name: '',
            displayKey: 'typekey.PolicyPeriodStatus.Draft'
        }];

        $scope.policyTransactionTableConfig.policyTransactionStatus = translatePolicyTransactionStatuses(status);
        $scope.policyTransactionTableConfig.transactionStatus = status[1]; // draft
    }

    function translatePolicyTransactionStatuses(statuses) {
        statuses.forEach((status) => {
            TranslateService.translate({
                object: status,
                propName: 'name',
                displayKey: status.displayKey,
                scope: $scope
            });
        });

        return statuses;
    }

    function getPolicyBillingSummary(policyNumber) {
        return PolicyService.getPolicyBillingSummaryInfo(policyNumber);
    }

    function mapAccountDetails(accountDetails) {
        if (!accountDetails) {
            return;
        }


        $scope.accountInfo.publicID = accountDetails.publicID;
        $scope.accountInfo.policySummaries = accountDetails.policySummaries;
        $scope.accountInfo.accountNumber = accountDetails.accountNumber;
        $scope.accountInfo.canCreateSub = accountDetails.canUserCreateSubmission;

        setupAccountContactDetails(accountDetails.accountHolder);
    }


    function setupAccountContactDetails(accountHolder) {
        $scope.accountInfo.subtype = accountHolder.subtype;
        if (accountHolder.subtype === 'Person') {
            $scope.accountInfo.prefix = accountHolder.prefix;
            $scope.accountInfo.firstName = accountHolder.firstName;
            $scope.accountInfo.lastName = accountHolder.lastName;
            $scope.accountInfo.contactName = nameUtil.getDisplayName(accountHolder, ' ');
        } else {
            $scope.accountInfo.contactName = accountHolder.contactName;
        }

        $scope.accountInfo.primaryAddress = accountHolder.primaryAddress;

        if (accountHolder.primaryPhoneType === 'work' && angular.isDefined(accountHolder.workNumber) && accountHolder.workNumber.length > 0) {
            $scope.accountInfo.primaryPhoneNumber = phoneUtils.format(phoneUtils.parse(accountHolder.workNumber, defaultLocaleDetails.countryCode));
        } else if (accountHolder.primaryPhoneType === 'home' && angular.isDefined(accountHolder.homeNumber) && accountHolder.homeNumber.length > 0) {
            $scope.accountInfo.primaryPhoneNumber = phoneUtils.format(phoneUtils.parse(accountHolder.homeNumber, defaultLocaleDetails.countryCode));
        } else if (accountHolder.primaryPhoneType === 'mobile' && angular.isDefined(accountHolder.cellNumber) && accountHolder.cellNumber.length > 0) {
            $scope.accountInfo.primaryPhoneNumber = phoneUtils.format(phoneUtils.parse(accountHolder.cellNumber, defaultLocaleDetails.countryCode));
        }
    }

    /* Scope Functions*/

    /* Should this be scope level and overrideable?*/

    ctrl.showAddActivity = () => {
        $scope.activityTableConfig.showAddActivity = true;
    };

    ctrl.shouldShowAddActivityButton = () => {
        const permissionDTO = {
            permission: 'actcreate'
        };

        const actPromise = UserService.hasUserSystemPermission(permissionDTO);

        actPromise.then((showActivity) => {
            $scope.showAddActivityButton = showActivity;
        });
    };

    ctrl.shouldShowAddActivityButton();

    ctrl.goBackOne = () => {
        window.history.back();
    };

    ctrl.showCancellationForm = () => {
        $scope.formIsOpen = true;
        $scope.cancelFormIsVisible = true;
    };

    ctrl.hideCancellationForm = () => {
        $scope.formIsOpen = false;
        $scope.cancelFormIsVisible = false;
    };

    ctrl.showChangeForm = () => {
        $scope.formIsOpen = true;
        $scope.changeFormIsVisible = true;
    };

    ctrl.hideChangeForm = () => {
        $scope.formIsOpen = false;
        $scope.changeFormIsVisible = false;
    };

    ctrl.showRenewForm = () => {
        $scope.formIsOpen = true;
        $scope.renewFormIsVisible = true;
    };

    ctrl.hideRenewForm = () => {
        $scope.formIsOpen = false;
        $scope.renewFormIsVisible = false;
    };

    ctrl.policyContactTileIsActive = () => {
        return $state.includes('policies.detail.contacts')
            || $state.includes('policies.detail.contact-detail')
            || $state.includes('policies.detail.associated-contact-detail')
            || $state.includes('policies.detail.account-contact-detail');
    };

    function addRecentlyViewedPolicies() {
        PolicyService.addRecentlyViewedPolicy($stateParams.policyNumber);
    }

    $scope.$on('activitiesUpdated', (event, data) => {
        if (angular.isDefined($scope.policy)) {
            const openActivities = _.filter(data, {
                status: 'open'
            });
            if (openActivities.length !== $scope.policy.numberOfOpenActivities) {
                $scope.policy.numberOfOpenActivities = openActivities.length; // Set the number of open activities
            }
        }
    });

    $scope.$on('notesUpdated', (event, data) => {
        if (angular.isDefined($scope.policy)) {
            $scope.policy.numberOfNotes = data.length;
        }
    });

    $scope.$on('noteAdded', (/* event, data*/) => {
        if (angular.isDefined($scope.policy)) {
            $scope.policy.numberOfNotes++;
        }
    });

    $scope.$on('documentsUpdated', (event, data) => {
        if (angular.isDefined($scope.policy)) {
            $scope.policy.numberOfDocuments = data.length;
        }
    });

    return ctrl.create($scope);
};
fn.$inject = ['$translate', '$state', '$scope', '$q', '$stateParams', 'AccountService', 'PolicyService', 'ActivityService', '$modal', '$window', 'ModalService', '$filter', 'UserService', 'TranslateService', 'defaultLocaleDetails'];

export default fn;
